/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import ClientsTable from './components/ClientsTable'
import ClientsTableHeader from './components/ClientsTableHeader'
import { Button } from '../../common/Button/Button'
import Loading from '../../common/Loading/Loading'
import PopUp from '../../common/PopUp/PopUp'
import DatePicker from '../../common/DatePicker/DatePicker'
import { currency, symbol } from '../../common/CurrencyFormat'

/**
 *     Import
 *     - CSS
 */
import './styles/Clients.css'

/**
 * Clients section class
 *
 * @export
 * @class Clients
 * @extends {React.Component<any, any>}
 */
export default class Clients extends React.Component<any, any> {

    /**
     * Creates an instance of Clients.
     * @param {*} props
     * @memberof Clients
     */
    constructor(props: any) {
        super(props)
        this.state = {
            typeSelected: 'quotes',
            bindPopUp: {
                show: false,
                quoteId: '',
                quoteVariationId: '',
                businessName: '',
                quoteRef: '',
                inceptionDate: '',
                printDate: '',
                premium: Number,
                commission: '',
                excess: Number,
                policyName: '',
            },
            bindPopUpSendShow: false,
            quotes: [],
            policies: [],
            filters: {
                page: 1,
                perPage: 20,
                sortedBy: 'clientName',
                sortedType: 'asc',
            },
            boundBind: false,
        }
    }

    /**
     * Will check the URL before the component mounts and will redirect
     * to the correct site of the application
     *
     * @memberof Clients
     */
    componentWillMount() {
        let urlType = this.props.history.location.pathname.split('/')[
            this.props.history.location.pathname.split('/').length - 1
        ]

        if (urlType === 'clients' || urlType === '') {
            this.props.history.push('/clients/quotes')
        } else if (this.state.typeSelected !== urlType) {
            this.setState({ typeSelected: urlType })
        }
        this.props.fecthQuoteList()
        this.props.fecthPoliciesList()
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (this.state.filters !== nextState.filters) {
            this.props.fecthQuoteList(
                nextState.filters.page,
                nextState.filters.perPage,
                nextState.filters.sortedBy,
                nextState.filters.sortedType
            )
            this.props.fecthPoliciesList(
                nextState.filters.page,
                nextState.filters.perPage,
                nextState.filters.sortedBy,
                nextState.filters.sortedType
            )
        }
    }

    /**
     * Will handle the footer click for more data loading
     *
     * @memberof Clients
     */
    handleFooterClick = () => {
        this.setState({ filters: { perPage: this.state.filters.perPage + 20 } })
    }

    /**
     * Will change the section between quotes and policies
     *
     * @memberof Clients
     * @param {string} newType the new type to change: quotes or policies
     */
    changeSelectedType = (newType: string) => {
        this.props.history.push('/clients/' + newType)
        this.setState({ typeSelected: newType })
    }

    /**
     * Will update the component's state with the new data coming
     * from the childs components
     *
     * @memberof Clients
     * @param {string} type the type of the data to update
     * @param {Object} data the actual data to update the type with
     */
    updateData = (type: string, data: object) => {
        type = type.toLowerCase()
        switch (type) {
            case 'quotes':
                this.setState({ quotes: data })
                break

            case 'policies':
                this.setState({ policies: data })

                break
            default:
                break
        }
    }

    /**
     * Trigger fot the header filters
     *
     * @memberof Clients
     * @param {Object} params
     */
    filterTrigger = (params: any) => this.setState(
        {
            filters: {
                page: this.state.filters.page,
                perPage: this.state.filters.perPage,
                sortedBy: params.sortedBy,
                sortedType: params.sortedType,
            },
        }
    )

    /**
     * Handle the action of binding the quote from the PopUp
     *
     * @param {*} quoteId
     * @param {*} quoteVariationId
     * @memberof Clients
     */
    handleBind = (quoteId: any, quoteVariationId: any, inceptionDate: any) => {
        this.props.bindQuoteVariation(quoteId, quoteVariationId, inceptionDate).then((response) => {
            if (response.value) {
                this.setState({
                    boundBind: true,
                })
            }
        }).catch((response) => {
            if (response.error) {
                this.setState({
                    boundBind: false,
                })
            }
        })
        this.setState(
            {
                bindPopUp: {
                    show: false,
                    quoteId: '',
                    quoteVariationId: '',
                    businessName: '',
                    quoteRef: '',
                    inceptionDate: '',
                    printDate: '',
                    premium: Number,
                    commission: '',
                    excess: Number,
                    policyName: '',
                },
                bindPopUpSendShow: false,
                quoteVariationId,
            }
        )
    }

    printDate = () => {
        return this.state.bindPopUp.printDate
    }

    render() {
        // Sets the length of the array
        let quotesCount = (this.props.clientList.quoteList) ? this.props.clientList.quoteList.totalNumber : 0
        let policiesCount = (this.props.clientList.policyList) ? this.props.clientList.policyList.totalNumber : 0

        return (
            <div className="clients">
                {
                    (this.props.step05.error) ?
                        < PopUp
                            title="Something went wrong"
                            buttonText="Close"
                            action={() => {
                                this.props.step05.error = null
                                this.forceUpdate()
                            }}
                        >
                            {this.props.step05.error.error}
                        </ PopUp>
                        :
                        null
                }
                {
                    (this.state.boundBind) ?
                        <PopUp
                            title="Quote Bound"
                            buttonText="Quote Bound"
                            action={() =>
                                this.props.history.push(`/clients/quotes/bound/${this.props.step05.response.policy.id}`)
                            }
                        >
                            The quote has been bound
                        </PopUp> : null
                }

                <HeaderContainer
                    className="clients__header"
                    fullwidth={true}
                    titles={['quotes', 'policies']}
                    selected={this.state.typeSelected}
                    triggerAction={this.changeSelectedType}
                >
                    {(this.state.typeSelected === 'quotes') ?
                        <div className="quotesCount">
                            {`${quotesCount} active ${(quotesCount === 1) ? 'quote' : 'quotes'}`}
                        </div>
                        :
                        <div className="quotesCount">
                            {`${policiesCount} active ${(policiesCount === 1) ? 'policy' : 'policies'}`}
                        </div>}
                </HeaderContainer>

                {
                    this.state.bindPopUp.show &&
                    < PopUp
                        title="Select Inception Date"
                        buttonText="Cancel"
                        action={
                            () =>
                                this.setState(
                                    {
                                        bindPopUp: {
                                            show: false,
                                            quoteId: '',
                                            quoteVariationId: '',
                                            businessName: '',
                                            quoteRef: '',
                                            inceptionDate: '',
                                            printDate: '',
                                            premium: Number,
                                            commission: '',
                                            excess: Number,
                                            policyName: '',
                                        },
                                    }
                                )
                        }
                    >
                        <div className="quotePreview__box">
                            <div className="quotePreview__row">
                                <div className="text">
                                    Please enter the inception date:
                            </div>
                                <div className="quotePreview__row__inception_date">
                                    <DatePicker
                                        placeholder="Policy inception date"
                                        step05inceptionDate={this.printDate()}
                                        onChange={(inceptionDate) => this.setState(
                                            {
                                                bindPopUp:
                                                    { ...this.state.bindPopUp, inceptionDate, show: false },
                                                bindPopUpSendShow: true,
                                            }

                                        )}
                                        onFocus={() => null}
                                    />
                                </div>
                            </div>
                        </div>
                    </PopUp >
                }

                {
                    (this.state.bindPopUpSendShow) ?
                        < PopUp
                            title="Do you want to bind this quote?"
                            buttonText="Bind"
                            action={
                                () => {
                                    this.handleBind(
                                        this.state.bindPopUp.quoteId,
                                        this.state.bindPopUp.quoteVariationId,
                                        this.state.bindPopUp.inceptionDate
                                    )
                                }
                            }
                            numberButtons={2}
                            secondaryButtonText="Cancel"
                            secondaryAction={
                                () =>
                                    this.setState(
                                        {
                                            bindPopUp: {
                                                show: false,
                                                quoteId: '',
                                                quoteVariationId: '',
                                                businessName: '',
                                                quoteRef: '',
                                                inceptionDate: '',
                                                printDate: '',
                                                premium: Number,
                                                commission: '',
                                                excess: Number,
                                                policyName: '',
                                            },
                                            bindPopUpSendShow: false,
                                        }
                                    )
                            }
                        >
                            <div className="quotePreview__box">
                                <div className="quotePreview__header">
                                    <div className="quotePreview__header__title">
                                        {this.state.bindPopUp.businessName}
                                    </div>
                                    <div className="quotePreview__header__subtitle">
                                        {(this.state.bindPopUp.policyName === 'Collectors') ?
                                            'Collections Insurance' : 'Commercial Art Insurance'}
                                    </div>
                                    <div className="quotePreview__header__policyInfo">
                                        Policy no. <span>{this.state.bindPopUp.quoteRef}</span>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Inception date</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.inceptionDate}</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Date quoted</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.printDate}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="quotePreview__row">
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Premium</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{currency(this.state.bindPopUp.premium)}
                                            </span> inc.IPT
                                    </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Your commission</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{this.state.bindPopUp.commission}%</span>
                                        </div>
                                    </div>
                                    <div className="quotePreview__infoBlock">
                                        <div className="quotePreview__infoBlock__title">Excess</div>
                                        <div className="quotePreview__infoBlock__value">
                                            <span>{symbol()} {this.state.bindPopUp.excess}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </PopUp > :
                        null
                }

                {
                    (this.state.typeSelected === 'quotes') ?
                        <div>
                            <ClientsTableHeader
                                state={this.state}
                                dataType={this.state.typeSelected}
                                filterTrigger={this.filterTrigger}
                            />
                            <Container className="clients clients__table table__content" fullwidth={false}>
                                <ClientsTable
                                    clientList={this.props.clientList}
                                    dataType={this.state.typeSelected}
                                    updateData={this.updateData}
                                    history={this.props.history}
                                    confirmEditQuote={this.props.confirmEditQuote}
                                    bindClick={
                                        (quote, variation) => {
                                            this.setState(
                                                {
                                                    bindPopUp: {
                                                        show: true,
                                                        quoteId: quote.id,
                                                        quoteVariationId: variation.id,
                                                        businessName: quote.clientName,
                                                        quoteRef: variation.quoteRef,
                                                        inceptionDate: '',
                                                        printDate: quote.quotedDate,
                                                        premium: variation.premium,
                                                        commission: variation.commission,
                                                        excess: variation.excess,
                                                        policyName: quote.policyName,
                                                    },
                                                }
                                            )
                                        }
                                    }
                                />
                            </Container>
                            <div className="clients__footer">
                                <div className="clients__ clients__footer--brick quote_load_more" >
                                    {
                                        (this.props.clientList.loading) ?
                                            <Loading />
                                            :
                                            <Button type="submit" onClick={this.handleFooterClick}>Load more</Button>
                                    }
                                </div>
                            </div>

                        </div>
                        :
                        <div>
                            <ClientsTableHeader
                                state={this.state}
                                dataType={this.state.typeSelected}
                                filterTrigger={this.filterTrigger}
                            />
                            <Container
                                className="clients clients__table table__content"
                                fullwidth={false}
                            >
                                <ClientsTable
                                    clientList={this.props.clientList}
                                    dataType={this.state.typeSelected}
                                    updateData={this.updateData}
                                    history={this.props.history}
                                />
                            </Container>
                            <div className="clients__footer">
                                <div className="clients__ clients__footer--brick" >
                                    {
                                        (this.props.clientList.loading) ?
                                            <Loading />
                                            :
                                            <Button type="submit" onClick={this.handleFooterClick}>Load more</Button>
                                    }
                                </div>
                            </div>
                        </div>
                }
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/Clients.tsx